export default [
    {
        path: "/",
        name: "landing",
        meta: { 
            title: "Welcome to Repo Alnair", 
            // authRequired: true 
        },
        component: () => import("../views/landing/index"),
    },
];